import { Component, Input, OnInit } from '@angular/core';
import { TicketAdditionalFileDto, TicketButtonCommunicationDto, TicketDto, TicketHistoryCapturedFieldDto, TicketHistoryDto } from '../../../../../service/dto';
import { HttpTicketService } from '../../../../../service/http-ticket.service';
import { HttpFileService } from '../../../../../service/http-file.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PreviewModalComponent } from '../../../../../components/preview-modal/preview-modal.component';
import { TicketCommunicationDisplayModalComponent } from '../ticket-communication-display-modal/ticket-communication-display-modal.component';

@Component({
	selector: 'app-ticket-history',
	standalone: false,
	templateUrl: './ticket-history.component.html',
	styleUrl: './ticket-history.component.scss'
})
export class TicketHistoryComponent implements OnInit {
	@Input() ticket!: TicketDto;
	history?: TicketHistoryDto;

	constructor(private service: HttpTicketService, private fileService: HttpFileService, private modalService: NzModalService) {

	}
	ngOnInit(): void {
		this.service.getTicketHistory(this.ticket.id).subscribe(result => this.history = result);
	}

	doDownloadField(input: TicketHistoryCapturedFieldDto) {
		this.fileService.downloadFile(input.inputValue!).subscribe();
	}
	doPreviewField(input: TicketHistoryCapturedFieldDto) {
		const modal = this.modalService.create({
			nzTitle: 'Preview',
			nzContent: PreviewModalComponent,
			nzWidth: '75%',
			nzBodyStyle: { height: '80vh', overflow: 'auto' },
			nzFooter: null
		});

		modal.componentInstance!.file = input.inputValue;
	}
	doPreviewFile(input: TicketAdditionalFileDto) {
		const modal = this.modalService.create({
			nzTitle: 'Preview',
			nzContent: PreviewModalComponent,
			nzWidth: '75%',
			nzBodyStyle: { height: '80vh', overflow: 'auto' },
			nzFooter: null
		});

		modal.componentInstance!.file = input.uuid;
	}
	doDownloadFile(input: TicketAdditionalFileDto) {
		this.fileService.downloadFile(input.uuid!).subscribe();
	}
	doViewCommunication(input: TicketButtonCommunicationDto) {
		this.modalService.info({
			nzTitle: 'Preview',
			nzWidth: '75%',
			nzContent: TicketCommunicationDisplayModalComponent,
			nzMaskClosable: true,
		}).componentInstance!.data=input;
	}
}
